/**
 * Function used to stop application logix for a desired time
 * @param delay: time to wait in millis
 */
export const sleep = (delay: number): Promise<unknown> => {
  return new Promise(resolve => setTimeout(resolve, delay));
};
